import { render } from "./InsightRefineChat.vue?vue&type=template&id=28b04595&scoped=true"
import script from "./InsightRefineChat.vue?vue&type=script&lang=js"
export * from "./InsightRefineChat.vue?vue&type=script&lang=js"

import "./InsightRefineChat.vue?vue&type=style&index=0&id=28b04595&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b04595"]])

export default __exports__